module.exports = "/assets/career/questions/people.png?b6wwrOe";